// extracted by mini-css-extract-plugin
module.exports = {"multi":"MultiSuperTabComponent--multi--KLthwe1"};